module.exports = __webpack_public_path__ + "img/folder.3dc35430.svg";